module.exports = __webpack_public_path__ + "img/google-maps.d29f7cbd.png";